module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg3@2x.ba613a15.png";